import React from 'react';

// Gemeinsame CI-Klassen (gelocktes Blue-Glas-Light; Dark-Slot erhalten).
export const ci = (isDarkMode) => ({
  card: isDarkMode
    ? 'bg-gray-900/40 border border-white/15 backdrop-blur-xl rounded-2xl'
    : 'glass-light-card',
  panel: isDarkMode
    ? 'bg-gray-800/40 border border-white/10 rounded-xl'
    : 'bg-white border border-slate-200 rounded-xl',
  heading: isDarkMode ? 'text-white' : 'text-slate-900',
  sub: isDarkMode ? 'text-white/60' : 'text-slate-500',
  label: isDarkMode ? 'text-white/50' : 'text-slate-400',
  value: isDarkMode ? 'text-white/90' : 'text-slate-700',
});

// URL-Whitelist gegen Stored-XSS (Daten kommen aus Admin-Eingabe): nur root-relativ,
// Anker, http(s) oder mailto erlauben; javascript:/data:/sonstige Schemata verwerfen.
export const safeUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  const u = url.trim();
  if (u.startsWith('/') || u.startsWith('#')) return u;
  if (/^https?:\/\//i.test(u) || /^mailto:/i.test(u)) return u;
  return '';
};

// Block-Hülle: Karte mit Titel + Status-Badge. Rendert NICHTS bei status 'not_available'.
// status: 'loaded' | 'loading' | 'demo' | 'not_available'
export const BlockShell = ({ title, icon: Icon, status, isDarkMode, children }) => {
  if (status === 'not_available') return null;
  const c = ci(isDarkMode);
  return (
    <section className={`${c.card} p-5`}>
      <div className="flex items-center gap-2 mb-4">
        {Icon && <Icon className={`w-4 h-4 ${isDarkMode ? 'text-white/70' : 'text-brand'}`} />}
        <h2 className={`text-base font-semibold ${c.heading}`}>{title}</h2>
      </div>
      {status === 'loading' ? (
        <div className={`animate-pulse h-16 rounded-lg ${isDarkMode ? 'bg-white/10' : 'bg-slate-100'}`} />
      ) : (
        children
      )}
    </section>
  );
};
